package com.esoris.kmpmoout

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.esoris.kmpmoout.core.koin.initKoin
import com.esoris.kmpmoout.modules.webModule

@OptIn(ExperimentalComposeUiApi::class)
fun main() {

    initKoin(
        extraModules = listOf(
            webModule
        )
    )

    ComposeViewport {
        App()
    }
}